import { ThemeProperties } from '../../core';

export interface IconTheme {
	xSmallSize: string;
	smallSize: string;
	mediumSize: string;
	largeSize: string;
	xLargeSize: string;
}
export const theme = new ThemeProperties('icon');
